<header>
  <app-center-content>
    @if (disableOkLink) {
      <div class="logo-img">
        <img src="assets/images/ok-logo.svg" alt="OK a.m.b.a" />
      </div>
    } @else {
      <a class="logo-img" href="/" matTooltip="Gå til forsiden">
        <img src="assets/images/ok-logo.svg" alt="OK a.m.b.a" />
      </a>
    }
  </app-center-content>
</header>

<main>
  <router-outlet></router-outlet>
</main>

<footer>
  <img src="assets/images/ok-logo.svg" alt="OK a.m.b.a" />
  <div class="page_version">Version : {{ version }}</div>
</footer>
